import {
  ChangeStatusButton,
  ChatButton,
  DeleteButton,
  SendEmailButton,
  ViewButton,
} from "@/components/IconButton/variants";
import { STATUS } from "@/constant/statusConstants";
import PropTypes from "prop-types";
import React from "react";

function Actions({
  row,
  handleOnClickDelete,
  handleOnChangeStatus,
  enableStatus = true,
}) {
  return (
    <div className="w-auto flex gap-x-1 justify-center">
      <ViewButton onClick={() => alert("View Detail")} />
      <ChatButton onClick={() => alert("Chat")} />
      <SendEmailButton onClick={() => alert("Send Email")} />
      {enableStatus && (
        <ChangeStatusButton
          isActive={row.original.status === STATUS.ACTIVE}
          onClick={() => handleOnChangeStatus(row.original)}
        />
      )}
      <DeleteButton onClick={() => handleOnClickDelete(row.original)} />{" "}
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  handleOnClickDelete: PropTypes.func.isRequired,
  handleOnChangeStatus: PropTypes.func.isRequired,
  handleOnClickEdit: PropTypes.func.isRequired,
};

export default React.memo(Actions);
